(function(){
  var C = window.__PaisagenVIPCore;
  if (!C) { console.error('Paisagen VIP core missing'); return; }
  var subscribe = C.subscribe, getState = C.getState, turnOn = C.turnOn, turnOff = C.turnOff, addStandard = C.addStandard, openCartDrawer = C.openCartDrawer, convertAndFormat = C.convertAndFormat, fmtCents = C.fmtCents, parseJsonAttr = C.parseJsonAttr;
  var NECKLACE_USD = C.NECKLACE_USD, SHIPPING_USD = C.SHIPPING_USD, MEMBERSHIP_USD = C.MEMBERSHIP_USD, FREE_SHIP_THRESHOLD_USD = C.FREE_SHIP_THRESHOLD_USD;

  function initAnnouncement(){
    var bar = document.getElementById('pgAnnBar');
    var text = document.getElementById('pgAnnText');
    if (!bar || !text) return;
    if (bar.dataset.paisagenAnnInit) return;
    bar.dataset.paisagenAnnInit = 'true';
    subscribe(function(s){
      if (!s.cart) return;
      var on = s.inCart;
      bar.classList.toggle('is-on', on);
      text.innerHTML = on
        ? '<strong>80% OFF</strong> is on + Free Shipping'
        : 'Turn on <strong>80% OFF</strong> + Free Shipping';
    });
  }

  function initCard(){
    var card = document.getElementById('pgCard');
    if (!card) return;
    if (card.dataset.paisagenCardInit) return;
    card.dataset.paisagenCardInit = 'true';

    var toggle = document.getElementById('pgToggle');
    var btnAdd = document.getElementById('pgBtnAdd');
    var priceEl = document.getElementById('pgPrice');
    var priceWasEl = document.getElementById('pgPriceWas');
    var savingEl = document.getElementById('pgSaving');
    var headline = document.getElementById('pgToggleHeadline');
    var toggleSubEl = card.querySelector('.pgc-toggle-sub');
    var savingsBar = document.getElementById('pgSavingsBar');
    var learnBtn = document.getElementById('pgLearnBtn');
    var learnPanel = document.getElementById('pgLearnPanel');
    var shipText = card.querySelector('.pgc-ship-text');
    var countryName = card.getAttribute('data-country-name') || 'the US';
    if (!toggle || !btnAdd) return;

    var MONEY_FMT = card.getAttribute('data-money-format') || '${{amount}}';
    var VARIANTS = parseJsonAttr(card, 'data-variants') || [];
    var optSels = Array.from(card.querySelectorAll('.pgc-picker-select'));
    var localOn = false;
    var isAdding = false;

    if (learnBtn && learnPanel) {
      learnBtn.addEventListener('click', function(){
        var open = learnPanel.classList.toggle('open');
        learnBtn.classList.toggle('open', open);
        learnBtn.setAttribute('aria-expanded', String(open));
      });
    }

    function findBySelects(){
      if(!optSels.length) return null;
      var chosen = optSels.map(function(s){ return s.value; });
      return VARIANTS.find(function(v){ return (v.options||[]).every(function(o,i){ return String(o)===String(chosen[i]); }); }) || null;
    }
    function currentVariant(){
      var m = findBySelects();
      if (m) return m;
      return VARIANTS.find(function(v){ return String(v.id)===String(card.dataset.variantId); }) || VARIANTS[0];
    }

    function updateLocalPrices(){
      var necklaceF = convertAndFormat(NECKLACE_USD);
      var memF = convertAndFormat(MEMBERSHIP_USD);
      var creditF = convertAndFormat(MEMBERSHIP_USD*2);
      ['pgNecklaceVal','pgMemNecklaceVal','pgSavNecklaceLabel'].forEach(function(id){ var el=document.getElementById(id); if(el) el.textContent=necklaceF; });
      ['pgMemPrice','pgBillAmt','pgLegalAmt'].forEach(function(id){ var el=document.getElementById(id); if(el) el.textContent = id==='pgMemPrice' ? memF+'/month' : memF; });
      var creditEl = document.getElementById('pgCreditAmt'); if(creditEl) creditEl.textContent = creditF;
      var savNeck = document.getElementById('pgSavNecklace'); if(savNeck) savNeck.textContent = necklaceF;
      var savShip = document.getElementById('pgSavShipping'); if(savShip) savShip.textContent = convertAndFormat(SHIPPING_USD);
      var discEl = document.getElementById('pgDiscAmt'); if (discEl) discEl.textContent = memF;
      if (toggleSubEl) toggleSubEl.textContent = 'Free ' + necklaceF + ' Necklace + Free Shipping';
    }

    function render(isOn){
      localOn = isOn;
      toggle.classList.toggle('is-on', isOn);
      toggle.setAttribute('aria-checked', String(isOn));
      card.classList.toggle('pgc-gold', isOn);
      var vt = currentVariant();
      var price = vt ? vt.price : 0;
      var sale = Math.round(price*0.20);
      if (priceEl) priceEl.textContent = isOn ? fmtCents(sale, MONEY_FMT) : fmtCents(price, MONEY_FMT);
      if (priceWasEl) { priceWasEl.textContent = fmtCents(price, MONEY_FMT); priceWasEl.classList.toggle('show', isOn); }
      if (headline) headline.textContent = isOn ? '80% off is on' : 'Turn on 80% off';
      if (savingEl) savingEl.textContent = isOn ? 'You save '+fmtCents(price-sale, MONEY_FMT)+' with VIP' : 'Turn on 80% off to save '+fmtCents(price-sale, MONEY_FMT);
      if (savingsBar) savingsBar.classList.toggle('show', isOn);
      if (isOn && savingsBar) {
        var savProd = document.getElementById('pgSavProduct'); if(savProd) savProd.textContent = fmtCents(price-sale, MONEY_FMT);
        var savTotal = document.getElementById('pgSavTotal');
        var rate = 1; try{ rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1; }catch(e){}
        var totalCents = (price-sale) + Math.round(NECKLACE_USD*rate*100) + Math.round(SHIPPING_USD*rate*100);
        if(savTotal) savTotal.textContent = fmtCents(totalCents, MONEY_FMT);
      }
      if (shipText) shipText.textContent = isOn
        ? 'Free Shipping to ' + countryName + ' — Every Order, Always'
        : 'Free Shipping to ' + countryName + ' Over ' + convertAndFormat(FREE_SHIP_THRESHOLD_USD);
      if (!isAdding) btnAdd.textContent = isOn ? 'Add to Cart - VIP Price' : 'Add to Cart';
      updateLocalPrices();
    }

    subscribe(function(s){ if (s.cart) render(s.inCart); });

    toggle.addEventListener('click', function(){
      if (toggle.disabled) return;
      toggle.disabled = true;
      var goingOn = !localOn;
      var vt = currentVariant();
      var task = goingOn ? turnOn(vt ? vt.id : null) : turnOff();
      task.finally(function(){ toggle.disabled = false; });
    });

    btnAdd.addEventListener('click', function(){
      if (btnAdd.disabled) return;
      var vt = currentVariant();
      if (!vt || !vt.available) return;
      btnAdd.disabled = true; isAdding = true;
      var orig = btnAdd.textContent;
      btnAdd.textContent = 'Adding...';
      var task = localOn ? turnOn(vt.id) : addStandard(vt.id);
      task.then(function(){
        btnAdd.textContent = 'Added';
        setTimeout(function(){ btnAdd.disabled=false; isAdding=false; openCartDrawer(); },700);
      }).catch(function(){ btnAdd.disabled=false; isAdding=false; btnAdd.textContent=orig; });
    });

    optSels.forEach(function(s){ s.addEventListener('change', function(){ card.dataset.variantId = String(currentVariant().id); render(localOn); }); });

    (function(){
      var el=document.getElementById('pgTickerLine');
      if(!el) return;
      function rand(a,b){ return Math.floor(Math.random()*(b-a+1))+a; }
      var stock=parseInt(el.getAttribute('data-stock'),10)||7;
      var lines=[
        '<em>'+rand(110,168)+'</em> people are viewing this right now',
        '<em>'+rand(24,46)+'</em> VIP memberships claimed today',
        'Only <em>'+stock+'</em> pieces left in stock',
        '<em>'+rand(240,420)+'</em> VIP members active worldwide',
        '3-day free trial - <em>no charge today</em>'
      ];
      var idx=0;
      function show(){ el.innerHTML=lines[idx]; el.classList.add('show'); }
      function next(){ el.classList.remove('show'); setTimeout(function(){ idx=(idx+1)%lines.length; show(); },700); }
      show(); setInterval(next,6000);
    })();
  }

  window.PaisagenVIP = window.PaisagenVIP || {};
  Object.assign(window.PaisagenVIP, C, { initAnnouncement: initAnnouncement, initCard: initCard });
})();
